import axios from "axios";

export const api = axios.create({
    baseURL: "https://sut-api.hashstack.in"
    // baseURL: "https://sutapi.hashstack.in",
    // baseURL: "http://localhost:3030",
});

// attach token if exists
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("authToken");
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

export async function postData(url, payload) {
    const config =
        payload instanceof FormData
            ? { headers: { "Content-Type": "multipart/form-data" } }
            : {};
    const res = await api.post(url, payload, config);
    return res.data;
}

export async function getData(url, params) {
    const res = await api.get(url, { params });
    return res.data;
}

export const API_ENDPOINTS = {
    sendOtp: "/api/admin/sendOTPAdmin",
    verifyOtpLogin: "/api/admin/verifyOTPLoginAdmin",
    getUsersList: "/api/customer/getAllUsers",
    getAdminById: "/api/admin/getAdminById",
    deleteMultipleUsers: "/api/customer/deleteCustomer",
    getTruckOwners: "/api/truckOwner/getAllTruckOwners",
    deleteTruckOwners: "/api/truckOwner/deleteTruckOwner",
    getTrucks: "/api/truckDetails/getAllTrucks",
    updateAdmin: "/api/admin/updateUser",
    getDriversList: "/api/driver/getAllDrivers",
    dashboardSummary: "/api/dashboard/dashboardSummary",
    allTrips: "/api/trip/getAllTrips",
    insertCityData: "/api/region/createCity",
    getCitiesData: "/api/region/getAllCities",
    insertBoardingDropPoint: "/api/masterBoardingDropPoints/createBoardingDropPoint",
    markOnDuty: "/api/driver/updateDriverOnDutyStatus",
    fetchTripById: "/api/trip/getAdminTripById",
    tripAnalytics: "/api/dashboard/tripsChart",
    createDeliveryZone: "/api/deliveryZones/createCityDeliveryZone",
    getDeliveryZones: "/api/deliveryZones/getAllCityDeliveryZones",
    getAllCharges: "/api/charges/getAllCharges",
    updateCharge: "/api/charges/updateCharges",
    getPackages: "/api/packageManagement/getAllPackageSizes",
    createPackages: "/api/packageManagement/createPackageSize",
    updatePackages: "api/packageManagement/updatePackageSize",
    deletePackages: "/api/packageManagement/deletePackageSize",
    getTruckOwnerById: "/api/truckOwner/getAdminTruckOwnerById",
    getRevenueChart: "/api/dashboard/revenueChart",
    createOwnerPayment: "/api/initiatedPayments/initiateOwnerPayment",
    createBoardingPoints: "/api/masterBoardingDropPoints/createBoardingDropPoint",
    getOwnerPayments: "/api/initiatedPayments/getAllOwnerPayments",
    generateCharges: "/api/charges/createCharges",
    fetchDriverById: "/api/driver/getDriverById/:driver_id",
    getTruckDetailsById: "/api/truckDetails/getTruckByIdForAdmin/:truck_id",
    findCustomerById: "/api/customer/getCustomerById",
    fetchPackagesByCustomer: "/api/package/getAllPackagesByCustomerId",
    fetchAllPackages: "/api/package/getAllPackages",
    fetchPackageById: "/api/package/getPackageById",
};
